import { render, staticRenderFns } from "./SurveyQuestion.vue?vue&type=template&id=02f3a06a&"
import script from "./SurveyQuestion.vue?vue&type=script&lang=ts&"
export * from "./SurveyQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports